







import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class ProductResourceItem1ProductDescription extends Vue {

}

export default ProductResourceItem1ProductDescription


